<img
    [attr.ga-event-id]="popupGA[0].Cancel.event"
    [attr.ga-event-category]="popupGA[0].Cancel.category"
    [attr.ga-event-label]="popupGA[0].Cancel.label"
    ga-track="track"
    class="tw-top-6 tw-right-9 tw-absolute tw-cursor-pointer"
    [mat-dialog-close]="true"
    src="../../../../../assets/images/announcement-close.svg"
    (click)="closeDialog()"
    alt="Close announcement"
/>

<mat-dialog-content id="announcement-wrapper tw-w-full">
    <div class="!tw-mt-16 tw-items-center tw-w-full">
        <span
            *ngIf="
                type !== 'delete_document' &&
                type !== 'submit_wo_document' &&
                type !== 'duplicate_app'
            "
            class="tw-text-center tw-text-[21px] !tw-font-semibold tw-mt-4 tw-block tw-ml-0"
        >
            {{ "READY_TO_CHECK_ELIGIBILITY" | translate }}
        </span>
        <span
            *ngIf="type == 'delete_document'"
            class="tw-text-center tw-text-[21px] !tw-font-semibold tw-mt-4 tw-block tw-ml-0"
        >
            {{
                "NEW_APPLICATION.DOCUMENT_UPLOAD.ARE_YOU_SURE_WANT_TO_DELETE_THE_DOC"
                    | translate
            }}
        </span>
        <span
            *ngIf="type == 'submit_wo_document'"
            class="tw-text-center tw-text-[21px] !tw-font-semibold tw-mt-4 tw-block tw-ml-0"
        >
            {{
                "NEW_APPLICATION.DOCUMENT_UPLOAD.SUBMIT_WITHOUT_DOC_SUB"
                    | translate
            }}
        </span>
        <span
            *ngIf="type == 'duplicate_app' && appNo"
            [ngClass]="{'tw-text-center tw-text-[14.9px] !tw-font-semibold tw-mt-0 tw-block tw-ml-0': type === 'duplicate_app' && appNo}"
        >
            {{ "NEW_APPLICATION.DUPLICATE_APP_1" | translate }}
            {{ appNo }}
            {{ "NEW_APPLICATION.DUPLICATE_APP_2" | translate }}
        </span>

        <div class="tw-flex tw-justify-center">
            <button
                [attr.ga-event-id]="popupGA[0].Proceed.event"
                [attr.ga-event-category]="popupGA[0].Proceed.category"
                [attr.ga-event-label]="popupGA[0].Proceed.label"
                ga-track="track"
                [disabled]="disableSubmitBtn"
                class="tw-inline-block tw-mx-auto tw-mt-[2.5rem] tw-w-[80%] tw-h-16 tw-rounded-full tw-text-center tw-text-white btn-text"
                [ngClass]="
                    disableSubmitBtn
                        ? 'tw-bg-slate-300'
                        : 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                "
                (click)="onSubmit()"
            >
                <span
                    *ngIf="
                        type !== 'delete_document' && type !== 'duplicate_app'
                    "
                    >{{ "YES_PROCEED" | translate }}</span
                >
                <span *ngIf="type == 'delete_document'">{{
                    "NEW_APPLICATION.DOCUMENT_UPLOAD.YES_DELETE" | translate
                }}</span>
                <span *ngIf="type == 'duplicate_app'">
                    {{ "NEW_APPLICATION.DASHBOARD" | translate }}
                </span>
            </button>
            <mat-spinner
                *ngIf="resLoading"
                [diameter]="30"
                style="top: 56px"
            ></mat-spinner>
        </div>
    </div>
</mat-dialog-content>
